import React from 'react';

function Contact() {
    return (
        <div>
            <section id="contact-index">
                <div class="container">
                    <div class="section-heading"><br /><br />
                        <h2>Contact Us</h2>
                    </div>
                    <div class="col-lg-7 col-lg-offset-5 col-md-8 col-md-offset-2">
                        <h4>Information </h4>
                        <ul class="list-inline">
                            <li><i class="fa fa-envelope"></i><a href="mailto:youremailaddress">youremail @site.com</a></li>
                            <li><i class="fa fa-phone margin-icon"></i>Call Us +1 456 7890</li>
                            <li><i class="fa fa-map-marker margin-icon"></i>Lorem Ipsum 505</li>
                        </ul>
                        <p>
                            Elit uasi quidem minus id omnis a nibh fusce mollis imperdie tlorem ipuset phas ellus ac sodales Lorem ipsum dolor Phas ellus
                        </p>
                        <h4 class="margin1">Send us a Message</h4>

                        <div id="contact_results"></div>
                    </div>

                </div >

            </section >
        </div >
    )
}

export default Contact;